import script from "./DiagnosticsSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagnosticsSidebar.vue?vue&type=script&setup=true&lang=js"

import "./DiagnosticsSidebar.vue?vue&type=style&index=0&id=e94a0a80&lang=scss"

const __exports__ = script;

export default __exports__